import type { File, FilePayload } from './types';

export async function uploadFilesSequentially<T>(files: File[], uploadFn: (file: File) => Promise<T>): Promise<T[]> {
    const results = [];
    for (const file of files) {
        results.push(await uploadFn(file));
    }
    return results;
}

export function toFilePayload(file: File): FilePayload {
    return {
        fileName: file.file.name,
        mediaType: file.file.type || 'unknown/unknown', // Some files (e.g. *.md) have no type.,
        data: file.data,
    };
}
